import { Box, Button, Paper, Stack } from "@mui/material";
import React, {
  useContext,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { AuthContext } from "../../../AppContext/AuthContext";
import { RHFRichEditor } from "../../../Shared/RHFRichEditor";
import { useForm } from "react-hook-form";
import { Send, ChatBubbleOutline } from "@mui/icons-material";

const SendMessage = forwardRef(({ handleSend, title }, ref) => {
  const { currentUser } = useContext(AuthContext);
  const { register, handleSubmit, control, errors } = useForm();
  const [allowTyping, setAllowTyping] = useState(false);
  const hfControl = { register, errors };

  const openTyping = () => {
    setAllowTyping(true);
  };

  useImperativeHandle(ref, () => ({
    openTyping,
  }));

  if (allowTyping) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 2,
          ml: 2,
          mb: 2,
          borderRadius: 2,
          border: "1px solid #e0e0e0",
        }}
      >
        <RHFRichEditor
          required="Comment is required"
          label="Click here to add a comment"
          name="message"
          control={control}
          {...hfControl}
        />
        <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
          <Button
            onClick={() => setAllowTyping(false)}
            size="small"
            variant="outlined"
            sx={{ textTransform: "none", borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSubmit((data) => {
              handleSend(data.message, currentUser.uid);
              setAllowTyping(false);
            })}
            startIcon={<Send />}
            size="small"
            variant="contained"
            sx={{
              textTransform: "none",
              borderRadius: 2,
              background:
                "linear-gradient(135deg, #1a237e 0%, #283593 100%)",
            }}
          >
            Send
          </Button>
        </Stack>
      </Paper>
    );
  }

  if (!ref) {
    return (
      <Box sx={{ mb: 2, textAlign: "center" }}>
        <Button
          onClick={() => setAllowTyping(true)}
          variant="contained"
          startIcon={<ChatBubbleOutline />}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            background:
              "linear-gradient(135deg, #1a237e 0%, #283593 100%)",
          }}
        >
          {title}
        </Button>
      </Box>
    );
  }
  return null;
});

export default SendMessage;
